import { AboutUs } from 'components/main-page/about-us/AboutUs'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_ABOUT_US } from 'services/apiAboutUs'
import { Alert } from 'avo-ui'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { INITIAL_STATE, GET_FIELD_NAME, FIELD_NAME_DETAIL } from 'configs/main-page/configFormAboutUs'

export const AboutUsContainer = () => {
    const [reload, setReload] = useState(false)
    const [aboutUsDetail, setAboutUsDetail] = useState(INITIAL_STATE)
    const [imagesDetail, setImagesDetail] = useState([])
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getAboutUsDetail, isLoading } = useFetch(API_ABOUT_US.DETAIL)
    const { fetching: updateAboutUs, isLoading: isUpdating } = useFetch(API_ABOUT_US.UPDATE)
    const { fetching: getUrlImage } = useFetch(API_ABOUT_US.URL_ABOUT_US_IMAGE)

    const onChangeForm = (section, item) => {
        setAboutUsDetail({ ...aboutUsDetail, [section]: { ...aboutUsDetail[section], ...item } })
    }

    const onInsertImage = (item) => {
        imagesDetail?.push(item)
        setImagesDetail(imagesDetail)
    }

    const setUploadImages = async (filesName, uploadDetail) => {
        const newPayload = { ...aboutUsDetail }

        try {
            const s3Urls = await getUrlImage({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                const regexFindImage = new RegExp(`(<img[^>]+id="${uploadDetail[i]?.id}"[^>]+src=")([^"]+)`, 'g')
                newPayload[uploadDetail[i]?.name] = {
                    ...newPayload[uploadDetail[i]?.name],
                    description: newPayload[uploadDetail[i]?.name]?.description?.replace(
                        regexFindImage,
                        `$1${item?.url}${item?.fields?.key}`,
                    ),
                }
            })
            await Promise.all(apiS3list)
            onSave(newPayload)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        return new Promise((resolve, reject) => {
            const errors = {}
            Object.entries(aboutUsDetail).forEach(([key, item]) => {
                const result = {}
                Object.keys(item).forEach((i) => {
                    if (GET_FIELD_NAME[key][i] && !aboutUsDetail[key][i]) {
                        result[i] = `${GET_FIELD_NAME[key][i]} wajib diisi`
                    }
                })
                if (Object.keys(result).length) errors[key] = result
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const images = [...imagesDetail]
            const uploadDetail = []
            const filesName = []

            images?.map((item) => {
                if (aboutUsDetail[item?.name]?.description?.includes(`id="${item?.id}"`)) {
                    filesName.push(item?.file?.name?.replace(/\s/g, ''))
                    uploadDetail.push(item)
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...aboutUsDetail }) => {
        updateAboutUs(payload)
            .then(() => {
                setImagesDetail([])
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'About Us Updated !',
                })
            })
            .catch((error) => setErrorForm(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getAboutUsDetail().then((response) => setAboutUsDetail({ ...response?.data }))
    }, [reload])

    const props = {
        sectionProps: {
            aboutUsDetail,
            onChangeForm,
            onInsertImage,
            errorForm,
        },
        isLoading,
        isUpdating,
        isLoadingUpload,
        onSubmit,
    }

    return <AboutUs {...props} />
}
